import { styled } from '../../../config'
import { modalPadding } from '../constants'

export const Body = styled('div', {
  padding: `0 ${modalPadding}`
})
